import { render } from "./AddRole.vue?vue&type=template&id=e1e12924"
import script from "./AddRole.vue?vue&type=script&lang=js"
export * from "./AddRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__